import { render, staticRenderFns } from "./ParcelDataComponent.vue?vue&type=template&id=4401bee7&"
import script from "./ParcelDataComponent.vue?vue&type=script&lang=js&"
export * from "./ParcelDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports